/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum ContainerTypeEnum {
    CONTAINER_FLUID = 'CONTAINER_FLUID',
    CONTAINER = 'CONTAINER',
}